import { SubscriptionImport } from '../../pages/subscription/Import'
import OrderList from '../../pages/subscription/OrderList'
import PaymentList from '../../pages/subscription/PaymentList'
import RoutesMap from '../../route_control/RouteControl'

const SubscriptionRoute = () => {
    return [
        {
            path: RoutesMap.SUBSCRIPTION_ORDER_LIST.path,
            element: <OrderList />
        },
        {
            path: RoutesMap.SUBSCRIPTION_PAYMENT_LIST.path,
            element: <PaymentList />
        },
    ]
}

export default SubscriptionRoute;
